import { type ClientIntent } from '@/modules/session';
import { type CashierMethodTile } from '@/schemas/methods.schema';

import { needsRailChoice, resolvedPaymentMethodCode } from './apiRails';

/**
 * A catalogue with exactly one API tile and no wallet tiles is not a choice — unless that tile
 * lists more than one rail. Returning an intent lets the methods load land on `collectPayerWallet`
 * so the player is not asked to tap the only option. A wallet tile is a real choice, so mixed
 * catalogues stay on `selectMethod`. Multiple API tiles, or one tile with two rails, do too.
 */
export function clientIntentForSingleApiOption(tiles: CashierMethodTile[]): ClientIntent | null {
  if (tiles.some((tile) => tile.kind === 'wallet')) return null;
  const apiTiles = tiles.filter((tile) => tile.kind === 'api');
  const tile = apiTiles[0];
  if (apiTiles.length !== 1 || tile === undefined) return null;
  if (needsRailChoice(tile)) return null;
  const paymentMethodCode = resolvedPaymentMethodCode(tile, null);
  if (paymentMethodCode === null) return null;
  return {
    step: 'payerWallet',
    gatewayAccountId: tile.gatewayAccountId,
    label: tile.label,
    paymentMethodCode,
  };
}
